import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { Button, Row } from "@masterteam/mt-design-react";

import Table from "../../NewTable";
import PerformanceIndicatorForm from "./PerformanceIndicatorForm";
import { UnitOfMeasureForInitiative } from "../../../helpers";

import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete.svg";

import "./style.scss";

const initialModalState = {
  isOpen: false,
  data: null
};

const PerformanceIndicators = ({ isReadOnly }) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";
  const { values, setFieldValue } = useFormikContext();
  const [formModal, setFormModal] = useState(initialModalState);
  const [performanceIndicators, setPerformanceIndicators] = useState(
    values.InitiativeSpecificKPIs
  );

  const columns = [
    {
      key: "Code",
      cell: (item) =>
        performanceIndicators?.findIndex((el) => el?.ID === item?.ID) + 1,
      header: intl.formatMessage({ id: "common.code" }),
      width: "10%"
    },
    {
      key: "Name",
      cell: (item) => (isAr ? item?.ArabicName : item?.EnglishName),
      header: intl.formatMessage({
        id: "initiative.performance-indicator-name"
      }),
      width: "30%"
    },
    {
      key: "Description",
      cell: (item) =>
        isAr ? item?.ArabicDescription : item?.EnglishDescription,
      header: intl.formatMessage({
        id: "initiative.performance-indicator-description"
      }),
      width: "30%"
    },
    {
      key: "UnitOfMeasure",
      cell: (item) => {
        const unitOfMeasure = UnitOfMeasureForInitiative.find(
          (e) => e.value === item?.UnitOfMeasure
        );

        return isAr ? unitOfMeasure?.labelAr : unitOfMeasure?.label;
      },
      header: intl.formatMessage({ id: "kpi.unit-of-measure" }),
      width: "15%"
    },
    {
      key: "Value",
      cell: (item) =>
        item?.UnitOfMeasure === "MultipleChoice"
          ? item?.BooleanValue
            ? intl.formatMessage({ id: "common.yes" })
            : item?.BooleanValue === false
            ? intl.formatMessage({ id: "common.no" })
            : "---"
          : `${item?.Value} ${item?.UnitOfMeasure === "Percentage" ? "%" : ""}`,
      header: intl.formatMessage({ id: "common.value" }),
      width: "15%"
    }
  ];

  const actions = [
    {
      key: "edit",
      variant: "primary",
      Icon: EditIcon,
      "tooltip-position": "buttom",
      tooltip: "Update",
      onClick: (item) => {
        setFormModal({ isOpen: true, data: item });
      }
    },
    {
      key: "delete",
      variant: "error",
      Icon: DeleteIcon,
      "tooltip-position": "buttom",
      tooltip: "Delete",
      onClick: (item) => {
        setPerformanceIndicators(
          performanceIndicators.filter((e) => e.ID !== item.ID)
        );
      }
    }
  ];

  useEffect(() => {
    setFieldValue("InitiativeSpecificKPIs", performanceIndicators);
  }, [performanceIndicators]);

  return (
    <div className="performance-indicators">
      <Row align="center" justify="between">
        <div className="title-wrapper">
          {intl.formatMessage({
            id: "initiative.initiative-performance-indicators"
          })}
        </div>

        {!isReadOnly && (
          <Button
            shape="round"
            onClick={() => setFormModal({ isOpen: true, data: null })}
          >
            {intl.formatMessage({ id: "common.add" })}
          </Button>
        )}
      </Row>
      <Table
        data={performanceIndicators}
        columns={columns}
        actions={isReadOnly ? [] : actions}
        headerHasBackgroundColor
      />

      {formModal.isOpen && (
        <PerformanceIndicatorForm
          data={formModal.data}
          performanceIndicators={performanceIndicators}
          setPerformanceIndicators={setPerformanceIndicators}
          closeModal={() => setFormModal(initialModalState)}
        />
      )}
    </div>
  );
};

export default PerformanceIndicators;
